import React from 'react';
import { useContent } from '../../context/ContentContext';
import { DEFAULT_CORE_BELIEFS, resolveCoreBeliefs } from '../../data/coreBeliefs';

export default function EditorPanelCoreBeliefsDetail() {
  const { getContent, setContentValue } = useContent();
  const beliefs = resolveCoreBeliefs(getContent);

  const saveBeliefs = (items) => {
    setContentValue('beliefs.items', items);
  };

  const updateBelief = (index, patch) => {
    saveBeliefs(beliefs.map((belief, idx) => (idx === index ? { ...belief, ...patch } : belief)));
  };

  const removeBelief = (index) => {
    if (beliefs.length <= 1) {
      window.alert('You need at least one belief.');
      return;
    }
    if (!window.confirm('Remove this belief?')) return;
    saveBeliefs(beliefs.filter((_, idx) => idx !== index));
  };

  const addBelief = () => {
    saveBeliefs([
      ...beliefs,
      {
        title: DEFAULT_CORE_BELIEFS[0]?.title || 'Belief title',
        description: DEFAULT_CORE_BELIEFS[0]?.description || 'Description',
        verse_text: DEFAULT_CORE_BELIEFS[0]?.verse_text || 'Bible verse text',
        verse_ref: DEFAULT_CORE_BELIEFS[0]?.verse_ref || 'Reference',
      },
    ]);
  };

  return (
    <div className="editor-panel__detail" onClick={(e) => e.stopPropagation()}>
      <p className="editor-panel__detail-lead">
        Edit each belief&apos;s title, description, and supporting Bible verse.
      </p>

      <ul className="editor-panel__detail-list">
        {beliefs.map((belief, index) => (
          <li key={`belief-${index}`} className="editor-panel__detail-card">
            <div className="editor-panel__detail-card-head">
              <span className="editor-panel__detail-card-title">Belief {index + 1}</span>
              <span className="editor-panel__detail-card-subtitle">{belief.title || 'Untitled'}</span>
            </div>

            <label className="editor-panel__detail-label" htmlFor={`belief-${index}-title`}>
              Title
            </label>
            <input
              id={`belief-${index}-title`}
              type="text"
              className="editor-panel__detail-input"
              value={belief.title}
              onChange={(e) => updateBelief(index, { title: e.target.value })}
            />

            <label className="editor-panel__detail-label" htmlFor={`belief-${index}-description`}>
              Description
            </label>
            <textarea
              id={`belief-${index}-description`}
              className="editor-panel__detail-textarea"
              rows={3}
              value={belief.description}
              onChange={(e) => updateBelief(index, { description: e.target.value })}
            />

            <label className="editor-panel__detail-label" htmlFor={`belief-${index}-verse`}>
              Bible verse
            </label>
            <textarea
              id={`belief-${index}-verse`}
              className="editor-panel__detail-textarea"
              rows={2}
              value={belief.verse_text}
              onChange={(e) => updateBelief(index, { verse_text: e.target.value })}
            />

            <label className="editor-panel__detail-label" htmlFor={`belief-${index}-ref`}>
              Verse reference
            </label>
            <input
              id={`belief-${index}-ref`}
              type="text"
              className="editor-panel__detail-input"
              value={belief.verse_ref}
              placeholder="Book chapter:verse"
              onChange={(e) => updateBelief(index, { verse_ref: e.target.value })}
            />

            <div className="editor-panel__detail-btn-row">
              <button
                type="button"
                className="editor-panel__detail-btn editor-panel__detail-btn--danger"
                onClick={() => removeBelief(index)}
              >
                Remove belief
              </button>
            </div>
          </li>
        ))}
      </ul>

      <div className="editor-panel__detail-btn-row editor-panel__detail-btn-row--footer">
        <button type="button" className="editor-panel__detail-btn editor-panel__detail-btn--primary" onClick={addBelief}>
          + Add belief
        </button>
      </div>
    </div>
  );
}
